import * as React from 'react';
import {Props} from './model';
import View from './view';
import {useDeviceSize} from '../../theme/helpers';

export const ResponsiveView = (props: Props) => {
  const diviceSize = useDeviceSize();
  if (props.only && !props.only.includes(diviceSize)) {
    return null;
  }
  if (props.exclude && props.exclude.includes(diviceSize)) {
    return null;
  }

  return React.createElement(View, props);
};
